export const navList = [
  {
    id: 1,
    path: "/",
    text: "Home",
  },
  {
    id: 2,
    path: "/about",
    text: "About",
  },
  {
    id: 3,
    path: "/services",
    text: "Services",
  },
  {
    id: 4,
    path: "/rooms",
    text: "Rooms",
  },
  {
    id: 5,
    path: "/page",
    text: "Page",
    subItems: [
      {
        id: 51,
        path: "/booking",
        text: "Booking",
      },
      {
        id: 52,
        path: "/team",
        text: "Our Team",
      },
      {
        id: 53,
        path: "/testimonial",
        text: "Testimonial",
      },
    ],
  },
  {
    id:6,
    path:"/gallery",
    text:"Gallery",
  }

];
export const socialIcons = [
  {
    icon: <i className="fab fa-facebook-f" onClick={() => window.open("https://www.facebook.com/people/Gagana-vila-Kandy/61550020773154/", "_blank")}></i>,
    link: "https://www.facebook.com/people/Gagana-vila-Kandy/61550020773154/"
  },
  {
    icon: <i className="fab fa-twitter"></i>,
  },
  {
    icon: <i className="fab fa-instagram"></i>,
  },
  {
    icon: <i className="fab fa-linkedin-in"></i>,
  },
  {
    icon: <i className="fab fa-youtube"></i>,
  },
];

export const carouselData = [
  {
    img: "../assets/img/a1.png",
    title: "Discover A Brand Luxurious Vila",
    subtitle: "More Confortable",
    btn1: "Our Room",
    btn2: "Book Room",
  },
  {
    img: "../assets/img/a2.png",
    title: "Discover A Brand Luxurious Vila",
    subtitle: "More Confortable",
    btn1: "Our Room",
    btn2: "Book Room",
  },
  {
    img: "../assets/img/c1.png",
    title: "Discover A Brand Luxurious Hotel",
    subtitle: "luxury living",
    btn1: "Our Room",
    btn2: "Book Room",
  },
  {
    img: "../assets/img/c2.png",
    title: "Discover A Brand Luxurious Hotel",
    subtitle: "luxury living",
    btn1: "Our Room",
    btn2: "Book Room",
  },
  {
    img: "../assets/img/c3.png",
    title: "Discover A Brand Luxurious Hotel",
    subtitle: "luxury living",
    btn1: "Our Room",
    btn2: "Book Room",
  },
  {
    img: "../assets/img/c4.png",
    title: "Discover A Brand Luxurious Hotel",
    subtitle: "luxury living",
    btn1: "Our Room",
    btn2: "Book Room",
  },
  {
    img: "../assets/img/c5.png",
    title: "Discover A Brand Luxurious Hotel",
    subtitle: "luxury living",
    btn1: "Our Room",
    btn2: "Book Room",
  },
  {
    img: "../assets/img/c6.JPG",
    title: "Discover A Brand Luxurious Hotel",
    subtitle: "luxury living",
    btn1: "Our Room",
    btn2: "Book Room",
  },
];
export const about = [
  {
    icon: <i class="fa fa-hotel fa-2x text-primary mb-2"></i>,
    text: "Rooms",
    count: "5",
  },
  {
    icon: <i class="fa fa-users fa-2x text-primary mb-2"></i>,
    text: "Staffs",
    count: "7",
  },
  {
    icon: <i class="fa fa-users-cog fa-2x text-primary mb-2"></i>,
    text: "Clients",
    count: "74",
  },
  
];

export const services = [
  {
    icon: <i class="fa fa-hotel fa-2x text-primary"></i>,
    name: "Rooms & Appartment",
    discription: "Luxurious accommodations with modern amenities for a comfortable stay.",
  },
  {
    icon: <i class="fa fa-utensils fa-2x text-primary"></i>,
    name: "Food & Restaurant",
    discription: "Culinary delights prepared by skilled chefs in our onsite restaurant",
  },
 
  {
    icon: <i class="fa fa-glass-cheers fa-2x text-primary"></i>,
    name: "Event & Party",
    discription: "Elevate your celebrations with our spacious top-floor venue, perfect for memorable gatherings and special occasions.",
  },

  {
    icon: <i class="fa fa-dumbbell fa-2x text-primary"></i>,
    name: "GYM ",
    discription: "Our cozy fitness space offers essential equipment for a satisfying workout, ensuring you stay active and refreshed during your stay.",
  },
];
export const team = [
  {
    image: "../assets/img/t1.jpg",
    name: "D.D N de alwis",
    designation: "Manager",
  },
  {
    image: "../assets/img/t2.jpg",
    name: "P.M.D.U Premarathne",
    designation: "Assistance Manager",
  }
];

export const footerItem = [
  {
    id: 1,
    header: "Company",
    UnitItem: [
      {
        name: "About Us",
      },
      {
        name: "Contact Us",
      },
      {
        name: "Privacy Policy",
      },
      {
        name: "Terms & Condition",
      },
      {
        name: "Support",
      },
    ],
  },
  {
    id: 2,
    header: "Services",
    UnitItem: [
      {
        name: "Food & Restaurant",
      },
    
      {
        name: "Sports & Gaming",
      },
      {
        name: "Event & Party",
      },
      {
        name: "GYM",
      },
    ],
  },
];

export const footerContact = [
  {
    icon: <i className="fa fa-map-marker-alt me-3"></i>,
    name: "9/f water tank road uggalla Katugasthota 01, 20800 Kandy, Sri Lanka, Katugastota, Sri Lanka",
  },
  {
    icon: <i className="fa fa-phone-alt me-3"></i>,
    name: "+75 320 0446",
  },
  {
    icon: <i className="fa fa-envelope me-3"></i>,
    name: "gagana2001vila@gmail.com",
  },
];

export const contact = [
  {
    icon: <i class="fa fa-envelope-open text-primary me-2"></i>,
    title: "Booking",
    email: "book@example.com",
  },
  {
    icon: <i class="fa fa-envelope-open text-primary me-2"></i>,
    title: "Technical",
    email: "tech@example.com",
  },
  {
    icon: <i class="fa fa-envelope-open text-primary me-2"></i>,
    title: "General",
    email: "gagana2001vila@gmail.com",
  },
];
export const testimonial = [
  {
    description:
      "Air conditioning would be nice.",
    name: "Arunajith",
    profession: "Sri Lankan",
    icon: (
      <i class="fa fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "../assets/img/profile.png",
  },
  {
    description:
      "The property was sparkling clean and very spacious. Basic but everything proper. Location is beautiful. It is far out from the city and suitable only if you have your own private transport. Parking available at the property.",
    name: "Nadja",
    profession: "Germany",
    icon: (
      <i class="fa fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "../assets/img/profile.png",
  },
  {
    description:
      "Perfect stay our group of 3, travelling as a spiritual pilgrimage to sacred sites in Sri Lanka. The villa was spacious, clean and quiet. I especially enjoyed the covered outdoor seating upstairs for reading, taking meals and morning yoga/fitness. Nishan and her family were lovely hosts, even sharing her birthday festivities with us. It was also nice having the ability to buy food locally and make our own meals in comfort. I highly recommend this villa.",
    name: "Amy",
    profession: "United States",
    icon: (
      <i class="fa fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "../assets/img/profile.png",
  },
  {
    description:
      "Environment, Lonely, staff",
    name: "Carlo",
    profession: "United States",
    icon: (
      <i class="fa fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "../assets/img/profile.png",
  },
];

export const roomItems = [
  {
    img: "../assets/img/r3.png",
    price: "Rs.2000/night",
    name: "Normal Suite",
    star: [
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
    ],
    description:
      "The spacious room features a large, comfortable bed, providing a luxurious and private retreat for rest and rejuvenation. The bathroom, with modern fixtures and a roomy shower, is shared with other guests. This room is ideal for two people.",
    yellowbtn: "View Detail",
    darkbtn: "book now",
  },
  {
    img: "../assets/img/r3.png",
    price: "Rs.2000/night",
    name: "Normal Suite",
    star: [
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
    ],
    description:
      "The spacious room features a large, comfortable bed, providing a luxurious and private retreat for rest and rejuvenation. The bathroom, with modern fixtures and a roomy shower, is shared with other guests. This room is ideal for two people.",
    yellowbtn: "View Detail",
    darkbtn: "book now",
  },
  {
    img: "../assets/img/r1.png",
    price: "Rs.3000/night",
    name: "Executive Suite",
    star: [
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
    ],
    description:
      "The spacious room features a large, comfortable bed and an attached bathroom with modern fixtures and a roomy shower, providing a luxurious and private retreat for rest and rejuvenation.",
    yellowbtn: "View Detail",
    darkbtn: "book now",
  },
  
  

  {
    img: "../assets/img/r1.png",
    price: "Rs.3000/night",
    name: "Executive Suite",
    star: [
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
    ],
    description:
      "The spacious room features a large, comfortable bed and an attached bathroom with modern fixtures and a roomy shower, providing a luxurious and private retreat for rest and rejuvenation.",
    yellowbtn: "View Detail",
    darkbtn: "book now",
  },
  {
    img: "../assets/img/r2.png",
    price: "Rs.5000/night",
    name: "Super Deluxe",
    star: [
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
      <small class="fa fa-star text-primary"></small>,
    ],
    description:
      "The spacious, air-conditioned room features a large, comfortable bed and an attached bathroom with modern fixtures and a roomy shower, providing a luxurious and private retreat for rest and rejuvenation.",
    yellowbtn: "View Detail",
    darkbtn: "book now",
  },
];

export const facility = [
  {
    icon: <i class="fa fa-bed text-primary me-2"></i>,
    quantity: 1,
    facility: "King Size Bed",
  },
  {
    icon: <i class="fa fa-bath text-primary me-2"></i>,
    quantity: 1,
    facility: "bath",
  },
  {
    icon: <i class="fa fa-wifi text-primary me-2"></i>,
    facility: "Wifi",
  },
];

export const gallery=[
 {
  img:"/assets/img/Galleryimage/a.JPG",
  alt:"image",
 },
 {
  img:"/assets/img/Galleryimage/b.JPG",
  alt:"image",
 },
 {
  img:"/assets/img/Galleryimage/c.JPG",
  alt:"image",
 },
 {
  img:"/assets/img/Galleryimage/d.JPG",
  alt:"image",
 },
 {
  img:"/assets/img/Galleryimage/e.JPG",
  alt:"image",
 },
 {
  img:"/assets/img/Galleryimage/f.JPG",
  alt:"image",
 },
 {
  img:"/assets/img/Galleryimage/g.JPG",
  alt:"image",
 },
 {
  img:"/assets/img/Galleryimage/h.png",
  alt:"image",
 },
 
 
];